"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = exports.Endpoints = void 0;
exports.Endpoints = Object.freeze({
    GetBlockHashWitness: "/get_block_hash_witness",
    GetBlockMerkleProof: "/get_block_merkle_proof",
    GetBlockParams: "/get_block_params",
    GetBlockRlpHeader: "/get_block_rlp_header",
    GetBlockMmrProof: "/get_block_mmr_proof",
    GetAllQueries: "/get_all_queries",
    GetDataForQuery: "/get_data_for_query",
    GetQueryCount: "/get_query_count",
    GetQueryData: "/get_query_data",
    GetQuery: "/get_query",
});
exports.Path = Object.freeze({
    Block: "/block",
    Query: "/query",
});
//# sourceMappingURL=endpoints.js.map